<template>
  <div class="card-header m-b-10">
    <form
      class="box-search"
      @reset.prevent="triggerFilter(false)"
      @submit.prevent="triggerFilter()"
    >
      <div class="form-group">
        <DateRangePicker
          class="w-100"
          :ranges="false"
          v-model="search.saleTime"
        >
          <template v-slot:input="picker">
            <label v-if="picker.startDate && picker.endDate" class="align-middle text-center">
              {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
            </label>
            <label
              v-else
              style="min-width: 13.5em"
              class="align-middle font-size-12 time-placeholder"
            >
              Thời gian kích hoạt
            </label>
          </template>
        </DateRangePicker>
        <span
          v-show="search.saleTime.startDate || search.saleTime.endDate"
          class="position-absolute"
          style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer"
          @click="clearTime(search.saleTime)"
        >
          ✕
        </span>
      </div>
      <div class="form-group">
        <Select2 v-model="search.categoryId" :options="optionType" placeholder="Tên thiết bị"></Select2>
      </div>
      <div class="form-group">
        <input type="text" v-model.trim="search.serial" class="form-control f12 hc-37 text-search"
          placeholder="Mã thiết bị" />
      </div>

      <div class="form-group">
        <Select2 v-model="search.inventoryIds" :options="optionInventory" placeholder="Kho"></Select2>
      </div>
      <div class="form-group">
        <input type="text" v-model.trim="search.referralCode" class="form-control f12 hc-37 text-search"
          placeholder="Mã giới thiệu" />
      </div>
      <div class="form-group">
        <Select2 placeholder="Đối tác" v-model="search.partnerCode" :options="partnerCodeMap">
        </Select2>
      </div>

      <div class="form-group">
        <select2-multiple-control v-model="search.status" :options="optionStatus"
          :settings="{ placeholder: 'Trạng thái kích hoạt' }"></select2-multiple-control>
      </div>
      <div class="form-group">
        <DateRangePicker
          class="w-100"
          :ranges="false"
          v-model="search.deliveryTime"
        >
          <template v-slot:input="picker">
            <label v-if="picker.startDate && picker.endDate" class="align-middle text-center">
              {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
            </label>
            <label
              v-else
              style="min-width: 13.5em"
              class="align-middle font-size-12 time-placeholder"
            >
              Thời gian giao hàng
            </label>
          </template>
        </DateRangePicker>
        <span
          v-show="search.deliveryTime.startDate || search.deliveryTime.endDate"
          class="position-absolute"
          style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer"
          @click="clearTime(search.deliveryTime)"
        >
          ✕
        </span>
      </div>
      <div class="form-group">
        <Select2
          placeholder="Trạng thái giao hàng"
          v-model="search.shippingStatus"
          :options="getOptionShippingStatus">
        </Select2>
      </div>

      <!-- Action Filter -->
      <div class="form-group form-group-action action-h">
        <button type="submit" class="pt-2 mr-2 btn btn-primary hc-37">
          <i class="bx bx-filter-alt"></i> Lọc
        </button>
        <button type="reset" class="pt-2 mr-2 btn btn-outline-light hc-37">
          <i class="bx bx-filter-alt"></i> Bỏ lọc
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import moment from 'moment'
import { DeviceService } from '@/services/device.service'
import { CommonService } from '@/services/common.service'
import { showMessErrorResponse, showMessError } from '@/config/utils'
import Config from '@/thirdParty/config'
import cloneDeep from 'lodash/cloneDeep'

const searchDefault = {
  saleTime: {
    startDate: null,
    endDate: null
  },
  categoryId: '',
  serial: '',
  inventoryIds: '',
  referralCode: '',
  partnerCode: '',
  status: [],
  deliveryTime: {
    startDate: null,
    endDate: null
  },
  shippingStatus: ''
}
export default {
  name: 'FilterDeviceForm',
  data () {
    return {
      search: { ...cloneDeep(searchDefault) },
      listDevices: [],
      optionInventory: [],
      optionStatus: [
        ...Config.statusDevices
      ],
      optionType: [],
      partnerCodeMap: [],
      Config
    }
  },
  computed: {
    getOptionShippingStatus () {
      return this.Config.getSearch(this.Config.optionsShippingStatus)
    }
  },
  async created () {
    await this.fetchNameDevice()
    await this.fetchWarehouse()
    await this.fetchDataPartner()
  },
  methods: {
    triggerFilter (isFilter = true) {
      if (!isFilter) {
        this.search = { ...cloneDeep(searchDefault) }
      }
      const params = this.params()
      this.$emit('change', params)
    },
    clearTime (value) {
      value.startDate = null
      value.endDate = null
    },
    params () {
      const body = {}
      if (this.search.saleTime.startDate || this.search.saleTime.endDate) {
        body.dateFrom = moment(this.search.saleTime.startDate).startOf('day').valueOf()
        body.dateTo = moment(this.search.saleTime.endDate).endOf('day').valueOf()
      }
      if (this.search.deliveryTime.startDate || this.search.deliveryTime.endDate) {
        body.deliveryStartDate = moment(this.search.deliveryTime.startDate).startOf('day').valueOf()
        body.deliveryEndDate = moment(this.search.deliveryTime.endDate).endOf('day').valueOf()
      }
      if (this.search.categoryId) body.categoryId = this.search.categoryId.trim()
      if (this.search.serial) body.serial = this.search.serial
      if (this.search.inventoryIds && this.search.inventoryIds !== '0') {
        body.inventoryIds = [this.search.inventoryIds]
      }
      if (this.search.referralCode && this.search.referralCode !== '0') {
        body.referralCode = this.search.referralCode
      }
      if (this.search.partnerCode && this.search.partnerCode !== '0') {
        body.partnerCode = this.search.partnerCode
      }
      if (this.search.status.length !== 0) {
        body.status = this.search.status
      }
      if (this.search.shippingStatus && this.search.shippingStatus !== '0') {
        body.shippingStatus = this.search.shippingStatus
      }
      return body
    },
    async fetchNameDevice () {
      try {
        const response = await DeviceService.ListNameDevice({
          kind: 'SERIAL',
          agentView: true
        })
        if (response.code === 1000) {
          const filteredData = response.data || []
          this.optionType = filteredData.map((e) => ({ id: e.id, text: e.name })) || []
          this.optionType.unshift({ id: '0', text: 'Tất cả' })
        } else {
          showMessError(this, response.message)
        }
      } catch (error) {
        showMessErrorResponse(this, error)
      }
    },
    async fetchWarehouse () {
      try {
        const response = await DeviceService.ListWarehouseDevice()
        if (response.code === 1000) {
          this.optionInventory =
            response.data.map((e) => ({ id: e.id, text: e.name })) || []
          this.optionInventory.unshift({ id: '0', text: 'Tất cả' })
        } else {
          showMessError(this, response.message)
        }
      } catch (error) {
        showMessErrorResponse(this, error)
      }
    },
    async fetchDataPartner () {
      try {
        const response = await CommonService.getListAgentPartner({ page: 1, limit: 1000 })
        if (response.code === 1000) {
          this.partnerCodeMap = response.data.map((item) => {
            return {
              id: item?.code,
              text: item.name || ''
            }
          }) || []
          this.partnerCodeMap.unshift({ id: '0', text: 'Tất cả' })
        } else {
          showMessError(this, response.message)
        }
      } catch (error) {
        showMessErrorResponse(this, error)
      }
    }
  }
}
</script>
<style scoped>
  .action-h {
    height: 41px;
  }
</style>
